export const REDUCER_NAME = 'refinement'




// WEBPACK FOOTER //
// ./src/modules/refinement/state/const.js